import actions from "./actions"
import { mutations } from "./mutations"
import getters from "./getters"
import { LoginState } from "@/models/LoginState"

export default {
	namespaced: true,
	state: (): LoginState => {
		return {
			userJWT: null,
			communication: ''
		}
	},
	mutations,
	actions,
	getters
}
